import { cva, type VariantProps } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-white transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-brand-blue text-slate-50 shadow-sm hover:bg-slate-900/90 active:bg-slate-900',
        secondary: 'bg-brand-yellow text-slate-900 shadow-xs hover:bg-yellow-300/80 active:bg-yellow-300',
        destructive: 'bg-red-500 text-slate-50 shadow-xs hover:bg-red-500/90',
        destructiveSubtle: 'border border-red-200 bg-white shadow-xs text-red-500 hover:bg-red-500/90 hover:text-white',
        outline: 'border border-slate-200 bg-white shadow-xs hover:bg-slate-100 hover:text-slate-900',
        ghost: 'hover:bg-slate-100 hover:text-slate-900',
        link: 'text-slate-900 underline-offset-4 hover:underline',
        success: 'bg-emerald-600 text-slate-50 shadow-xs hover:bg-emerald-700 active:bg-emerald-800',
      },
      size: {
        default: 'h-9 px-4 py-2',
        sm: 'h-8 rounded-md px-3 text-xs',
        lg: 'h-10 rounded-md px-8',
        icon: 'h-9 w-9',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
